import { FormMultiselect } from '@shared/ui';
import { useGetScheduleWork } from '@entities/scheduleWork';
import { Loader, type MultiSelectProps } from '@mantine/core';

interface FormGuideScheduleWorkProps extends MultiSelectProps {
  title?: string;
  description?: string;
  placeholder?: string;
}

export const FormGuideScheduleWork = ({
  title = 'График работы',
  description = 'Укажите график работы',
  placeholder = 'Выберите',
  ...props
}: FormGuideScheduleWorkProps) => {
  const { data, isLoading } = useGetScheduleWork();

  const displayPlaceholder =
    props.value && !!props.value.length ? '' : placeholder;

  return (
    <FormMultiselect
      {...props}
      title={title}
      description={description}
      placeholder={displayPlaceholder}
      data={data?.map(item => ({
        label: item.name,
        value: item.id.toString(),
      }))}
      rightSection={isLoading ? <Loader size='xs' /> : null}
      searchable
    />
  );
};
